export default {
  leapCycles: [4, 100, 400],
  eras: [
    {
      duration: 9007199254740992,
      hasLeapYears: false,
      leapOffset: 0,
      index: 0,
      isBackwards: true,
      name: "BC",
      shortName: "BC"
    },
    {
      duration: 9007199254740992,
      hasLeapYears: true,
      leapOffset: 0,
      index: 1,
      isBackwards: false,
      name: "AD",
      shortName: "AD"
    }
  ],
  hoursInDay: 24,
  months: [
    {
      index: 0,
      leapDuration: 31,
      name: "January",
      normalDuration: 31,
      shortName: "Jan"
    },
    {
      index: 1,
      leapDuration: 29,
      name: "February",
      normalDuration: 28,
      shortName: "Feb"
    },
    {
      index: 2,
      leapDuration: 31,
      name: "March",
      normalDuration: 31,
      shortName: "Mar"
    },
    {
      index: 3,
      leapDuration: 30,
      name: "April",
      normalDuration: 30,
      shortName: "Apr"
    },
    {
      index: 4,
      leapDuration: 31,
      name: "May",
      normalDuration: 31,
      shortName: "May"
    },
    {
      index: 5,
      leapDuration: 30,
      name: "June",
      normalDuration: 30,
      shortName: "Jun"
    },
    {
      index: 6,
      leapDuration: 31,
      name: "July",
      normalDuration: 31,
      shortName: "Jul"
    },
    {
      index: 7,
      leapDuration: 31,
      name: "August",
      normalDuration: 31,
      shortName: "Aug"
    },
    {
      index: 8,
      leapDuration: 30,
      name: "September",
      normalDuration: 30,
      shortName: "Sep"
    },
    {
      index: 9,
      leapDuration: 31,
      name: "October",
      normalDuration: 31,
      shortName: "Oct"
    },
    {
      index: 10,
      leapDuration: 30,
      name: "November",
      normalDuration: 30,
      shortName: "Nov"
    },
    {
      index: 11,
      leapDuration: 31,
      name: "December",
      normalDuration: 31,
      shortName: "Dec"
    }
  ],
  weekdayIndexAtZero: 1,
  weekdays: [
    {
      index: 0,
      name: "Sunday",
      shortName: "Sun"
    },
    {
      index: 1,
      name: "Monday",
      shortName: "Mon"
    },
    {
      index: 2,
      name: "Tuesday",
      shortName: "Tue"
    },
    {
      index: 3,
      name: "Wednesday",
      shortName: "Wed"
    },
    {
      index: 4,
      name: "Thursday",
      shortName: "Thu"
    },
    {
      index: 5,
      name: "Friday",
      shortName: "Fri"
    },
    {
      index: 6,
      name: "Saturday",
      shortName: "Sat"
    }
  ],
  zeroDateTimestamp: 63587376000
};
